import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LockKey, User } from '@phosphor-icons/react';
import { useAuth } from '../../contexts/AuthContext';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';

const LOGO_GLOBAL = "https://customer-assets.emergentagent.com/job_mmd-global/artifacts/84lvvojb_WhatsApp%20Image%202026-03-25%20at%2021.12.59.jpeg";

export default function LoginPage() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });

    const handleInputChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(formData.username, formData.password);
            toast.success('Connexion réussie');
            navigate('/administration/dashboard');
        } catch (error) {
            console.error('Login error:', error);
            toast.error('Identifiants incorrects');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="login-page" className="min-h-screen flex items-center justify-center bg-mmd-dark-bg p-4">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-md"
            >
                <div className="bg-mmd-surface-dark border border-white/10 rounded-2xl p-8">
                    <div className="text-center mb-8">
                        <img src={LOGO_GLOBAL} alt="MMD Global" className="h-20 w-20 rounded-full mx-auto mb-4" />
                        <h1 className="font-heading text-2xl font-medium text-white">Administration</h1>
                        <p className="text-mmd-silver/70 text-sm mt-2">Connectez-vous pour accéder au tableau de bord</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <Label htmlFor="username" className="text-white">Nom d'utilisateur</Label>
                            <div className="relative mt-1">
                                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-mmd-silver/50" size={18} />
                                <Input
                                    id="username"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleInputChange}
                                    className="pl-10 bg-mmd-dark-bg border-white/20 text-white"
                                    placeholder="Entrez votre nom d'utilisateur"
                                    required
                                    data-testid="login-username"
                                />
                            </div>
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-white">Mot de passe</Label>
                            <div className="relative mt-1">
                                <LockKey className="absolute left-3 top-1/2 -translate-y-1/2 text-mmd-silver/50" size={18} />
                                <Input
                                    id="password"
                                    name="password"
                                    type="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    className="pl-10 bg-mmd-dark-bg border-white/20 text-white"
                                    placeholder="Entrez votre mot de passe"
                                    required
                                    data-testid="login-password"
                                />
                            </div>
                        </div>
                        <Button
                            type="submit"
                            disabled={loading}
                            data-testid="login-submit"
                            className="w-full bg-mmd-gold text-mmd-dark-bg hover:bg-mmd-gold-hover py-5 font-medium"
                        >
                            {loading ? 'Connexion...' : 'Se connecter'}
                        </Button>
                    </form>
                </div>
            </motion.div>
        </div>
    );
}
